/**
 * Add or update config within user education collection to be dismissed
 * @param {Array} education - collection of users current educations
 * @param {Object} config - configuration for key to set as dismissed
 */
export const dismissEducationPayload = (education = [], config = {}) => {
  const result = [...education];
  const educationForConfigIndex = education.findIndex((edu) => {
    return edu.context === config.context && edu.feature === config.feature;
  });

  if (educationForConfigIndex > -1) {
    result[educationForConfigIndex].dismissed = true;
  } else {
    result.push({
      ...config,
      dismissed: true
    });
  }
  return result;
};

/**
 * Manually clear all matching storage keys
 * Prod
 * Object.keys(window.localStorage).filter((key) => /^priceblocs-education-/.test(key)).forEach((key) => window.localStorage.removeItem(key));
 * Dev
 * Object.keys(window.localStorage).filter((key) => /^priceblocs-dev-education-/.test(key)).forEach((key) => window.localStorage.removeItem(key));
 * Legacy
 * window.localStorage.removeItem("priceblocs-dev-education")
 */
const APP_EDUCATION =
  process.env.NODE_ENV === "production"
    ? "priceblocs-education"
    : "priceblocs-dev-education";

export const getEducation = () => {
  if (typeof window !== "undefined") {
    /* eslint-disable-next-line no-useless-catch */
    try {
      const data = window.localStorage.getItem(APP_EDUCATION);
      return data ? JSON.parse(data) : {};
    } catch (err) {
      throw err;
    }
  } else {
    return {};
  }
};

export const setEducationSeen = (key) => {
  if (typeof window !== "undefined") {
    /* eslint-disable-next-line no-useless-catch */
    try {
      const data = getEducation();
      data[key] = true;
      window.localStorage.setItem(APP_EDUCATION, JSON.stringify(data));
    } catch (err) {
      throw err;
    }
  }
};
